"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useScrollToTop_1 = require("../../../../../../common/hooks/navigation/useScrollToTop");
var EnquiryForm_1 = require("../../../commonSteps/enquiryForm/components/enquiryForm/EnquiryForm");
var core_1 = require("@material-ui/core");
var VehicleSummary_1 = require("./vehicleSummary/VehicleSummary");
var useDealStatusAssertion_1 = require("../../../../common/react/useDealStatusAssertion");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var useEnquiryNextStep_1 = require("../../common/hooks/useEnquiryNextStep");
var EnquiryScreen = function () {
    var _a;
    useDealStatusAssertion_1.default((_a = {},
        _a[globalTypes_1.JourneyType.reserve_online] = false,
        _a[globalTypes_1.JourneyType.continue_in_dealership] = 8000,
        _a[globalTypes_1.JourneyType.online_order] = false,
        _a));
    useScrollToTop_1.default();
    var goToNextStep = useEnquiryNextStep_1.default(globalTypes_1.JourneyType.continue_in_dealership).goToNextStep;
    return (<core_1.Container>
      <VehicleSummary_1.default />
      <EnquiryForm_1.default journeyType={globalTypes_1.JourneyType.continue_in_dealership} goToNextStep={goToNextStep}/>
    </core_1.Container>);
};
exports.default = EnquiryScreen;
